var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663ZM7.62908 5.63963C7.37337 5.46916 7.04458 5.45326 6.77361 5.59828C6.50265 5.7433 6.3335 6.02568 6.3335 6.33301V9.66634C6.3335 9.97367 6.50265 10.2561 6.77361 10.4011C7.04458 10.5461 7.37337 10.5302 7.62908 10.3597L10.1291 8.69305C10.3609 8.5385 10.5002 8.2783 10.5002 7.99968C10.5002 7.72105 10.3609 7.46086 10.1291 7.3063L7.62908 5.63963Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackVideo);
export default __webpack_public_path__ + "static/media/black-video.52f988390911de518465c7af98cf3290.svg";
export { ForwardRef as ReactComponent };